// Maps a hunt's species + weapon to relevant marketplace gear categories.
// Category keys match Marketplace GEAR_CATS. Reasons explain the recommendation.
export function huntGearCategories({ species, weapon } = {}) {
  const w = (weapon || "").toLowerCase();
  const sp = (species || "").toLowerCase();
  const cats = [];
  const add = (key, label, reason) => { if (!cats.find((c) => c.key === key)) cats.push({ key, label, reason }); };

  if (w.includes("arch") || w.includes("bow")) add("Archery", "Archery", "Your weapon");
  if (w.includes("rifle") || w.includes("muzzle") || w.includes("gun") || w.includes("shotgun")) add("Optics", "Optics", "Glass & scope");

  add("Optics", "Optics", "Spot game early");
  add("Packs", "Packs", "Haul your kit & meat");
  add("Boots", "Boots", "Cover the miles");
  add("Clothing", "Apparel", "Layer for the season");
  add("Accessories", "Accessories", "Tools, safety & calls");

  if (sp.includes("elk") || sp.includes("deer") || sp.includes("turkey") || sp.includes("waterfowl")) add("Calls & Decoys", "Calls & Decoys", `${species} calling`);
  if (sp.includes("waterfowl") || sp.includes("bear") || sp.includes("sheep") || sp.includes("goat")) add("Camping", "Camping", "Backcountry stays");

  return cats;
}
